/* eslint-disable */ 
if(process.env.NODE_ENV !== 'development') {
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', 'UA-173163840-1');
}